import React from 'react';
import {navigateTo} from 'gatsby-link'
import Helmet from 'react-helmet'
import Layout from '../components/Layout'
import Background from '../components/Background'
import PrismicDOM from 'prismic-dom'
import {RichText} from 'prismic-reactjs';
import Link from 'gatsby-link'
import styled from 'styled-components'
import Grid from 'styled-components-grid';
import {Margin, Padding, py, ml} from 'styled-components-spacing'
import {GridContainer, FullImage, IntroGridUnit, SpacedGridUnit, OpacSpacedGridUnit} from '../components/Styles'
import Button from '@material-ui/core/Button';
import { findUrl } from '../components/Navigation.js'

const RelativeLink = styled(Link)`
  position: relative;
  display: block;
`;
const Name = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background: linear-gradient(to left, rgba(255,255,255,.1), rgba(255,255,255,.8), rgba(255,255,255,.1));
  left: 0;
  text-align: center;
  ${py(2)};
  color: black;
`;

const ImageLink = (props) => (
  <Grid.Unit size={1/3}>
    <Margin horizontal={2}>
      <RelativeLink to={props.to}>
        <FullImage src={props.image} />
        <Name>{props.name}</Name>
      </RelativeLink>
    </Margin>
  </Grid.Unit>
);

const IndexPage = ({data}) => {
  const content = data.content.data;
  return (
    <Layout 
      navigationLinks={data.menu.data.body}
      meteoLinks={data.meteo.data}
      pagesUrl={data.allPagesUrl}
      bannerImages={content.header_images}
    >
     <Helmet
      title={content.meta_title}
      meta={[
        { name: 'description', content: content.meta_description }
      ]}
      />
      <Background backgroundImage={content.background}>
        <Padding bottom={4}>
          <GridContainer>
            <Grid horizontalAlign="center">
              <IntroGridUnit>
                {RichText.render(content.introduction)}
              </IntroGridUnit>
              <Grid.Unit size={3/5}>
                <OpacSpacedGridUnit>
                  {content.body.map((pricelist, id) => {
                    return (
                      <table key={`category-${id}`}>
                        <thead>
                          <th colspan={2}>{pricelist.primary.category}</th>
                        </thead>
                        <tbody>
                          {pricelist.items.map((prices, idd) => (
                            <tr key={`price-${pricelist.primary.category}-${idd}`}>
                              <td width="70%">
                                <strong>{prices.price_title}</strong><br />
                                {prices.description}
                                {prices.link_to_a_content.slug && 
                                  <Margin left={2} inline>
                                    <Button size="small" color="primary" variant="outlined" onClick={() => navigateTo(findUrl(prices.link_to_a_content.slug, data.allPagesUrl))}>En savoir plus</Button>
                                  </Margin>
                                }
                              </td>
                              <td valign="top" align="right">CHF {prices.price}.—</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )
                  })}
                  { content.action && content.action != 'none' && (
                    content.action == 'prices' ?
                      <Button onClick={() => navigateTo('/tarifs') } variant="contained" color="primary">Tarifs</Button>
                      :
                      <Button onClick={() => navigateTo('/contact') } variant="contained" color="primary">Contact</Button>
                  )}
                </OpacSpacedGridUnit>
              </Grid.Unit>
            </Grid>
          </GridContainer>
        </Padding>
      </Background>
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query PageTarifsContent {
    menu: prismicDocument(type: {eq: "navigation"}) {
      ...NavigationLinks
    }
    meteo: prismicDocument (type: {eq: "menu_meteo"}){
      ...MenuMeteo
    }
    allPagesUrl: allSitePage {
      ...PagesUrl
    }
    content: prismicDocument(type: {eq: "tarifs"}) {
      data {
        meta_description 
        meta_title
        header_images {
          slideshow_image {
            url
            alt
            xl { url }
            md { url }
            sm { url }
          }
        }
        introduction {
          text
          type
          spans {
            start
            end
            type
          }
        }
        background {
          url
          xl { url }
          md { url }
          sm { url }
        }
        action
        body {
          primary {
            category
          }
          items {
            price_title
            description
            link_to_a_content {
              slug
            }
            price
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/tarifs.js